var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProxyswap(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 34,
    viewBox: "0 0 35 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.8273 2.40832C17.8273 4.17529 17.6869 4.34458 16.2208 4.34458C5.72601 4.34458 -2.56417 14.8906 1.10871 23.5689C2.14082 26.0075 2.54035 25.8531 4.12458 22.4032C5.80981 18.7332 8.50163 16.6055 12.7078 15.6186C17.5265 14.4878 17.8273 14.5548 17.8273 16.7593C17.8273 19.7467 18.5003 19.5824 24.5931 15.1069C31.5255 10.0145 31.5072 10.6684 24.8795 5.06542C18.7661 -0.103287 17.8273 -0.456797 17.8273 2.40832ZM26.1507 8.10037C27.5241 9.32132 28.5229 10.4206 28.3703 10.5439C22.0811 15.6297 19.492 16.9502 19.492 15.072V13.6281L15.4445 13.8323C10.0748 14.1022 6.56003 15.8581 4.09795 19.4994C1.99433 22.6096 1.45552 22.0973 1.8495 17.3607C2.38497 10.9256 7.45342 7.00002 16.8562 5.73702C19.2101 5.42114 19.492 5.23415 19.492 3.98776V2.59199L21.5728 4.2367C22.7176 5.14121 24.7774 6.87998 26.1507 8.10037ZM31.3307 19.1431C29.2582 24.0994 25.2524 26.8677 19.7328 27.1587L16.9949 27.3031L16.8229 25.2285C16.6237 22.8337 4.48305 29.7317 4.51856 32.2195C4.55574 34.8623 16.5821 42.6344 16.8212 40.1698L16.9949 38.3768L19.9952 37.9492C30.8812 36.398 37.2604 27.5532 33.6702 18.9871C32.6569 16.569 32.3995 16.5862 31.3307 19.1431Z",
    fill: "#2D62AE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProxyswap);
export default __webpack_public_path__ + "static/media/proxyswap.a6d9fa8ba699772bee8a142c82eb65c5.svg";
export { ForwardRef as ReactComponent };